import {API_URL, apiPatch} from '../api'

export const editBadge = async (id: string, data: any) => {
    return await apiPatch(API_URL, `admin/badges/${id}`, data)
}
